module.exports = __webpack_public_path__ + "img/hands-heart.3119100.svg";